// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img[data-v-02856900]{min-width:230px;max-width:300px;width:100%}.people-desc *[data-v-02856900]{font-family:monospace}", ""]);
// Exports
module.exports = exports;
